export class NotifierListener {
    public static bindClick(element: HTMLElement, onClick: (event: Event) => void): void {
        element.addEventListener("click", onClick);
    }
}
